<template>
  <div style="overflow: auto; width: 100%;">
    <div style="min-width: 500px;max-height: 700px; padding: 5px;">
      <Bar 
        :chart-options="chartOptions"
        :chart-data="getChartData()"
        :chart-id="chartId"
        :dataset-id-key="datasetIdKey"
        :plugins="plugins"
        :css-classes="cssClasses"
        :styles="styles"
        :width="width"
        :height="height"
      />
    </div>
    <v-pagination v-if="pageCount > 1"
      v-model="currentPage"
      :length="pageCount"  :total-visible="15"
      color="primary"
      class="mt-4"
    />
  </div>
</template>

<script>
import { Bar } from "vue-chartjs/legacy";
import ChartDataLabels from "chartjs-plugin-datalabels";

import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale
} from "chart.js";

ChartJS.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale, ChartDataLabels);

export default {
  name: "BarChart",
  components: {
    Bar
  },
  props: {
    chartId: {
      type: String,
      default: "bar-chart"
    },
    datasetIdKey: {
      type: String,
      default: "label"
    },
    width: {
      type: Number,
      default: 400
    },
    height: {
      type: Number,
      default: 400
    },
    cssClasses: {
      default: "",
      type: String
    },
    styles: {
      type: Object,
      default: () => {}
    },
    plugins: {
      type: Object,
      default: () => {}
    },
    labels: {
      type: Array,
      default: () => []
    },
    datasets: {
      type: Array,
      default: () => []
    },
    scales: {
      type: Object,
      default: () => {}
    },
    chartOptions: {
      type: Object,
      default: () => ({
        indexAxis: "x",
        responsive: true,
        maintainAspectRatio: false,
        plugins: {},
        scales: {},
        datalabels: {}
      })
    }
  },
  data() {
    return {
      chartData: {
        labels: this.labels,
        datasets: this.datasets
      },
      pageSize: 15,
      currentPage: 1
    };
  },
  computed: {
    pageCount() {
      return Math.ceil(this.labels.length / this.pageSize);
    },
    paginatedLabels() {
      const start = (this.currentPage - 1) * this.pageSize;
      const end = start + this.pageSize;
      return this.labels.slice(start, end);
    },
    paginatedDatasets() {
      const start = (this.currentPage - 1) * this.pageSize;
      const end = start + this.pageSize;
      return this.datasets.map(dataset => ({
        ...dataset,
        data: dataset.data.slice(start, end)
      }));
    },


  },
  methods:{
    getChartData() {
      return {
        labels: this.paginatedLabels,
        datasets: this.paginatedDatasets
      };
    }
  }
};
</script>
